var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletegroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1817_4328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 47,
    height: 47,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1817_4328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.811 40.1456C13.8345 40.1456 13.0002 39.7997 12.3083 39.1081C11.6166 38.4162 11.2708 37.5819 11.2708 36.6054V11.7497H9.3125V8.81222H18.125V7.08008H29.875V8.81222H38.6875V11.7497H36.7292V36.6054C36.7292 37.5947 36.3865 38.432 35.701 39.1174C35.0156 39.8028 34.1783 40.1456 33.189 40.1456H14.811ZM33.7917 11.7497H14.2083V36.6054C14.2083 36.7813 14.2648 36.9257 14.3777 37.0387C14.4907 37.1516 14.6351 37.2081 14.811 37.2081H33.189C33.3398 37.2081 33.4778 37.1452 33.6032 37.0196C33.7288 36.8942 33.7917 36.7562 33.7917 36.6054V11.7497ZM18.9162 33.2914H21.8532V15.6664H18.9162V33.2914ZM26.1468 33.2914H29.0838V15.6664H26.1468V33.2914Z",
    fill: "#FF4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletegroup);
export default __webpack_public_path__ + "static/media/deletegroup.4e04d5bea61303e10a99644a6a03ba3d.svg";
export { ForwardRef as ReactComponent };